var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#3D3D3D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 39,
    fill: "current"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 36,
    fill: "#3D3D3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 34.5H62.5V41.5L61.2763 42.2342C59.3366 43.398 56.9134 43.398 54.9737 42.2342L53.75 41.5L52.5263 42.2342C50.5866 43.398 48.1634 43.398 46.2237 42.2342L45 41.5L43.7763 42.2342C41.8366 43.398 39.4134 43.398 37.4737 42.2342L36.25 41.5L35.0263 42.2342C33.0866 43.398 30.6634 43.398 28.7237 42.2342L27.5 41.5V34.5Z",
    stroke: "#FF8F01",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43.6778V62.5H59V43.25",
    stroke: "current",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 34.3444V27.5H59V34.5",
    stroke: "current",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.375 52H40.625V62.5H49.375V52Z",
    stroke: "current",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.18028d38dfcf79ec7ad27d0ff5fde8e9.svg";
export { ForwardRef as ReactComponent };